import FileDownloadIcon from "@mui/icons-material/FileDownload";
import { Button, Identifier } from "react-admin";
import { useSiteExportButton } from "./hooks/useSiteExportButton";

const SiteExportButton = ({ siteId }: { siteId: Identifier }) => {
  const { handleClick } = useSiteExportButton(siteId);
  return (
    <Button variant="contained" color="primary" onClick={handleClick} label="Export" startIcon={<FileDownloadIcon />} />
  );
};

export default SiteExportButton;
